import { FunctionComponent } from 'react';
import styles from "./ContentTabs.module.css";
import cn from 'classnames';

export enum IContentTabsTheme {
    GREEN= 'themeGreen',
    DEFAULT= 'themeDefault',
};

interface IContentTabsProps {
    tabs: string[];
    defaultActiveTab: string;
    tabOnClick: (tab: string, index: number) => void;
    theme?: IContentTabsTheme;
    className?: string;
};

const ContentTabs: FunctionComponent<IContentTabsProps> = ({tabs, className, defaultActiveTab, tabOnClick, theme=IContentTabsTheme.DEFAULT }) => {

    return (
        <div className={cn(styles.tabberWrap, styles[theme || ''] ,className)}>
            {tabs.map((tab, index) => (
                <button
                    key={tab}
                    className={cn(styles.tabButton, defaultActiveTab === tab && styles.active)}
                    onClick={() => tabOnClick(tab, index)}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
};

export default ContentTabs;
